/* eslint-disable no-shadow */
import React, { useState } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { Types } from 'mongoose';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { enGB } from 'date-fns/locale';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import { useReportData } from '../useReportData';
import { createBotCustomReport } from '../../../../../store/actions/reports';
import InputDropdown from '../../../../../bergmannsoft/components/Widgets/Forms/InputDropdown';

const initialDate = {
  startDate: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
  inputStartDate: '',
  endDate: moment()
    .add(1, 'day')
    .set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
  inputEndDate: '',
};
const allId = Types.ObjectId().toString();
const nothingId = Types.ObjectId().toString();
const specialDropdownItems = [
  { _id: nothingId, name: 'Nenhum', value: '', type: '' },
  { _id: allId, name: 'Todos', value: '', type: '' },
];

const sessionVariables = [
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'Número de contato',
    value: 'contactNumber',
  },
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'Canal',
    value: 'channel',
  },
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'Duração da sessão',
    value: 'sessionDuration',
  },
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'Duração do atendimento humano',
    value: 'humanDuration',
  },
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'Duração da fila do atendimento humano',
    value: 'humanQueueDuration',
  },
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'Data do inicio da sessão',
    value: 'startSessionDate',
  },
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'Data do fim da sessão',
    value: 'endSessionDate',
  },
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'A sessão finalizou?',
    value: 'theSessionEnded',
  },
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'O atendimento humano começou?',
    value: 'theHumanStarted',
  },
  {
    _id: Types.ObjectId().toString(),
    type: 'custom',
    name: 'O atendimento humano finalizou?',
    value: 'theHumanEnded',
  },
];

const BotCustomReportForm = (props) => {
  const { fileFormat, sessionId, botVariables, match, hideVariables } = props;

  const formatedBotVariables = botVariables.map(({ _id, type, name }) => {
    return { _id, name: `Variável - ${name}`, value: name, type };
  });

  const allVariables = _.union(
    specialDropdownItems,
    sessionVariables,
    formatedBotVariables
  );

  const { botid: botId } = match.params;
  const [checkedVariables, setCheckedVariables] = useState([]);
  const { reportData, errors, isDataValid, onChangeFormField } = useReportData({
    name: '',
    webhook: null,
    fileFormat,
    variables: ['Nenhum'],
    ...(sessionId && { sessionId }),
    ...(!sessionId && { ...initialDate }),
  });

  const updateVariablesSpecialOption = (lastCommand, hasAll, hasNothing) => {
    if (hasAll && lastCommand === hasAll) {
      const options = allVariables.filter(({ _id }) => _id !== nothingId);

      const newVariables = options.map(({ _id }) => _id);
      setCheckedVariables(newVariables);

      const newVariablesFormatted = options
        .filter(({ _id }) => _id !== allId)
        .map(({ type, name, value }) => {
          return type === 'user' ? `variable.${value}` : value;
        });
      onChangeFormField(newVariablesFormatted, 'variables');
    }

    if (hasNothing && lastCommand === hasNothing) {
      onChangeFormField(['Nenhum'], 'variables');
      setCheckedVariables([nothingId]);
    }
  };

  const updateVariablesCommonOption = (value, hasAll, hasNothing) => {
    const options = allVariables.filter(
      ({ _id }) => _id !== nothingId && _id !== allId
    );
    let newVariables = value
      .map((id) => {
        const newValue = options.find(({ _id }) => _id === id);

        if (newValue) {
          return newValue.type === 'user'
            ? `variable.${newValue.value}`
            : newValue.value;
        }
        return null;
      })
      .filter(Boolean);

    if (hasAll) {
      const count = allVariables.length - 2 - value.length - 1;
      if (count < allVariables.length - 2) {
        newVariables = newVariables.filter((v) => v !== 'Todos');
        value = value.filter((v) => v !== allId);
      }
    } else if (hasNothing) {
      newVariables = newVariables.filter((v) => v !== 'Nenhum');
      value = value.filter((v) => v !== nothingId);
    } else if (value.length === allVariables.length - 2) {
      value = [allId, ...value];
    }

    setCheckedVariables(value);
    onChangeFormField(newVariables, 'variables');
  };

  const getReportEndpointType = () => {
    switch (fileFormat) {
      case 'CSV':
        return 'messages';
      case 'PDF':
        return 'session';
      default:
        return 'session';
    }
  };

  const onChangeVariablesDropdown = (value) => {
    const lastCommand = value[value.length - 1];
    const hasAll = value.find((v) => v === allId);
    const hasNothing = value.find((v) => v === nothingId);
    const specialLastCommand =
      lastCommand && (lastCommand === allId || lastCommand === nothingId);

    if (specialLastCommand && (hasAll || hasNothing)) {
      updateVariablesSpecialOption(lastCommand, hasAll, hasNothing);
    } else {
      updateVariablesCommonOption(value, hasAll, hasNothing);
    }
  };

  const onClickSubmitForm = () => {
    const isValid = isDataValid();

    if (!isValid) {
      toastr.error('Falha', 'Por favor, preencha corretamente os campos');
      return;
    }

    const { user, createBotCustomReport } = props;
    const token = (user && user.dashboard_token) || '';
    const {
      sessionId: session,
      startDate,
      endDate,
      name,
      webhook,
      variables,
    } = reportData;

    const body = {
      bot: botId,
      name,
      fileFormat,
      variables,
      token,
      webhook,
      type: getReportEndpointType(),
      ...(session && { session }),
      ...(startDate && {
        start_date:
          startDate instanceof Date
            ? new Date(startDate.setHours(0, 0, 0, 0))
            : startDate,
      }),
      ...(endDate && {
        end_date:
          endDate instanceof Date
            ? new Date(endDate.setHours(0, 0, 0, 0))
            : endDate,
      }),
    };

    createBotCustomReport(body);
  };

  const renderInputError = (field) => {
    return (
      <>
        {Array.isArray(errors) && errors.indexOf(field) > -1 && (
          <span className="custom-report-text-danger">
            Este campo é obrigatório
          </span>
        )}
      </>
    );
  };

  const renderPeriodInputError = (value) => {
    if (!value) {
      return 'Este campo é obrigatório';
    }

    if (String(value) === 'Invalid Date') {
      return 'Data inválida';
    }

    return '';
  };

  const renderPeriodInputs = () => {
    return (
      <div className="custom-report-container-hours-plus">
        <label className="custom-report-form-date-label less-words">
          Período*
        </label>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enGB}>
          <KeyboardDatePicker
            id="custom-report-time-picker-from"
            className="MuiInputAdornment-hiddenLabel"
            format="dd/MM/yyyy"
            autoOk
            required
            ampm={false}
            value={reportData.startDate}
            inputValue={reportData.inputStartDate}
            variant="inline"
            onChange={(date) => onChangeFormField(date, 'startDate')}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            InputProps={{ disableUnderline: true, margin: 'none' }}
            invalidDateMessage="Data inválida"
            helperText={renderPeriodInputError(reportData.startDate)}
          />
          <label className="custom-report-label-time-picker custom-report-form-left-period">
            até:
          </label>
          <KeyboardDatePicker
            id="custom-report-time-picker-to"
            format="dd/MM/yyyy"
            className="custom-report-form-left-period"
            autoOk
            ampm={false}
            value={reportData.endDate}
            inputValue={reportData.inputEndDate}
            variant="inline"
            onChange={(date) => onChangeFormField(date, 'endDate')}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            InputProps={{
              disableUnderline: true,
            }}
            invalidDateMessage="Data inválida"
            helperText={renderPeriodInputError(reportData.endDate)}
          />
        </MuiPickersUtilsProvider>
      </div>
    );
  };

  const renderSessionIdInput = () => {
    return (
      <>
        <div className="custom-report-form-container-input-sessionId">
          <label className="custom-report-form-container-label less-words">
            Sessão*
          </label>
          <input
            id="sessionId"
            type="text"
            name="sessionId"
            maxLength={40}
            value={reportData.sessionId}
            disabled
            onChange={(event) =>
              onChangeFormField(event.target.value, 'sessionId')
            }
          />
        </div>
        {renderInputError('sessionId')}
      </>
    );
  };

  const renderVariablesDropdown = () => {
    return (
      <>
        <div className="custom-report-form-container-input-variables">
          <label className="custom-report-form-container-label less-words custom-report-label-variables">
            Campos*
          </label>
          <InputDropdown
            className="custom-report-dropdown-variables"
            placeholder="Selecionar campos"
            dropdownItemsList={allVariables || []}
            dropdownItemsChecked={checkedVariables || []}
            onChange={onChangeVariablesDropdown}
            useCheckbox
            messageNoItems="Não há campos cadastrados"
          />
        </div>
        {renderInputError('variables')}
      </>
    );
  };

  return (
    <form id="custom-report-form">
      <div className="custom-report-form-container-input-name">
        <label className="custom-report-form-container-label less-words">
          Nome*
        </label>
        <input
          id="name"
          type="text"
          name="name"
          placeholder="Ex.: Relatório Janeiro"
          maxLength={30}
          onChange={(event) => onChangeFormField(event.target.value, 'name')}
        />
      </div>
      {renderInputError('name')}
      {reportData.fileFormat === 'CSV' && renderPeriodInputs()}
      {reportData.fileFormat === 'PDF' && renderSessionIdInput()}
      {!hideVariables && renderVariablesDropdown()}
      <div className="custom-report-form-container-input-webhook">
        <label className="custom-report-form-container-label more-words">
          Webhook
        </label>
        <input
          id="webhook"
          type="text"
          name="webhook"
          maxLength={100}
          placeholder="https://exemplo.com/api/recebe-relatorio"
          onChange={(event) => onChangeFormField(event.target.value, 'webhook')}
        />
      </div>
      {renderInputError('webhook')}
      <div>
        <button
          className="btn btn-primary custom-report-submit-button"
          type="button"
          onClick={onClickSubmitForm}
        >
          <p className="custom-report-submit-button-p">Produzir Relatório</p>
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = (state) => ({
  user: state.users.signedUser,
  botVariables: state.variables.variablesState.variables.bot,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ createBotCustomReport }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BotCustomReportForm)
);
